import * as React from 'react';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { useControl } from 'react-map-gl';

export default function DrawControl(props) {
  const draw = useControl(
    () => new MapboxDraw(props),
    ({ map }) => {
      map.on('draw.create', props.onCreate);
      map.on('draw.update', props.onUpdate);
      map.on('draw.delete', props.onDelete);
    },
    ({ map }) => {
      map.off('draw.create', props.onCreate);
      map.off('draw.update', props.onUpdate);
      map.off('draw.delete', props.onDelete);
    },
    { position: props.position }
  );

  React.useEffect(() => {
    props.onInstance?.(draw);
  }, [draw]);

  React.useEffect(() => {
    if (!draw || !props.defaultMode) return;
    try { draw.changeMode(props.defaultMode); } catch { }
  }, [draw, props.defaultMode]);

  return null;
}

DrawControl.defaultProps = {
  onCreate: () => { },
  onUpdate: () => { },
  onDelete: () => { }
};
